import styled, { css } from "../../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectTypography } from "../../../utils/injectTypography.mjs.mjs";
import { responsiveStyles } from "../../../utils/responsiveStyles.mjs.mjs";
import { injectSpacing } from "../../../api/spacing/injectSpacing.mjs.mjs";
import { injectOSXFontSmoothing } from "../../../utils/injectOSXFontSmoothing.mjs.mjs";
export const StyledContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledContainer", componentId: "auir-611444a-1tp4l4s" }) `
  display: grid;

  grid-template-rows: 48px;
  ${injectSpacing('margin')}

  ${(props) => responsiveStyles({
    'grid-template-columns': {
        xs: '[select] auto [prev] 48px [next] 48px',
        m: '[prev] 48px [select] auto [next] 48px',
    },
}, props.theme.breakpoints)}
`;
export const StyledArrow = styled.svg.withConfig({ displayName: "auir-611444a-StyledArrow", componentId: "auir-611444a-1ikqi6q" }) `
  display: inline-block;

  vertical-align: middle;
`;
export const StyledSelectContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledSelectContainer", componentId: "auir-611444a-1dbixeg" }) `
  display: flex;
  grid-row: 1;
  grid-column: select;

  align-items: center;

  ${(props) => responsiveStyles({
    'justify-content': {
        m: 'center',
    },
}, props.theme.breakpoints)}
`;
export const StyledSelect = styled.button.withConfig({ displayName: "auir-611444a-StyledSelect", componentId: "auir-611444a-10gkyhk" }) `
  ${(props) => injectTypography(props, 'copy1')}
  ${injectOSXFontSmoothing(true)}

  display: inline-flex;
  align-items: center;

  min-height: 48px;
  margin: 0;
  padding: 0;
  padding-inline-end: var(${(props) => props.theme.responsive.spacing.s});
  padding-inline-start: var(${(props) => props.theme.responsive.spacing.s});

  color: var(${(props) => props.theme.colors.interaction.secondary.filled});

  background-color: transparent;
  border: none;
  border-radius: 0;

  transition: color 150ms var(${(props) => props.theme.easing});

  appearance: none;

  &:enabled {
    cursor: pointer;
  }

  &:disabled {
    color: var(${(props) => props.theme.colors.interaction.secondary.disabled});
  }

  &:focus,
  &:hover {
    color: var(${(props) => props.theme.colors.interaction.secondary.hover});
  }
`;
export const StyledSmallArrowContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledSmallArrowContainer", componentId: "auir-611444a-ofh1ds" }) `
  margin-inline-start: var(${(props) => props.theme.responsive.spacing.xxs});
  /* Fixes odd shape when focusing back on the parent button */
  overflow: hidden;

  & > ${StyledArrow} {
    transition: color, transform 150ms var(${(props) => props.theme.easing});

    ${(props) => props.open &&
    css `
        transform: scaleY(-1);
      `}
  }
`;
export const StyledArrowButton = styled.button.withConfig({ displayName: "auir-611444a-StyledArrowButton", componentId: "auir-611444a-1uijadj" }) `
  grid-row: 1;
  grid-column: ${(props) => props.direction};
  margin: 0;
  padding: 0;

  color: var(${(props) => props.theme.colors.interaction.secondary.default});

  background-color: transparent;
  border: none;

  transform: ${(props) => props.direction === 'prev' ? 'scaleX(-1)' : 'scale(1)'};

  cursor: pointer;

  transition: color 150ms var(${(props) => props.theme.easing});

  appearance: none;

  [dir='rtl'] & {
    transform: ${(props) => props.direction === 'prev' ? 'scaleX(1)' : 'scale(-1)'};
  }

  &:disabled {
    color: var(${(props) => props.theme.colors.interaction.secondary.disabled});

    cursor: not-allowed;
  }

  &:enabled:focus,
  &:enabled:hover {
    color: var(${(props) => props.theme.colors.interaction.secondary.hover});
  }
`;
//# sourceMappingURL=CalendarHeader.styles.mjs.mjs.map